import { render } from "./select2Page.vue?vue&type=template&id=a1c39dde"
import script from "./select2Page.vue?vue&type=script&lang=js"
export * from "./select2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__